interface ICommonApi {
    API_KEY: string;
    VOX_ACCOUNT_ID: string;
    VOX_API_KEY: string;
}

export interface IDynamicApi {
    CLIENT_AUTH_URL: string;
    MANAGER_AUTH_URL: string;
    STATIC_API: string;
    VIDEO_CALL_API: string;
    /** Название приложения в кабинете VOX */
    VOX_APP_NAME: string;
}

type IApi = ICommonApi & IDynamicApi;
type Team = '01' | '02' | '03' | '04' | '05' | '06' | '07' | '08' | '09' | '11';

const commonApi: ICommonApi = {
    API_KEY: 'ffc34a705ffb5',
    VOX_ACCOUNT_ID: '5322592',
    VOX_API_KEY: '4c00725f-9558-4437-a91e-5087131d1428',
};

function getTeamApi(team: Team): IDynamicApi {
    return {
        CLIENT_AUTH_URL: `https://trendrealty.trend-team-${team}.tech/auth`,
        MANAGER_AUTH_URL: `https://spb.trend-team-${team}.tech/login`,
        STATIC_API: `https://static.trend-team-${team}.tech`,
        VIDEO_CALL_API: `https://meetings-api.trendrealty.trend-team-${team}.tech`,
        VOX_APP_NAME: 'videocalls-dev',
    };
}

const stageApi: IDynamicApi = {
    CLIENT_AUTH_URL: 'https://trendrealty.trend-stage.tech/auth',
    MANAGER_AUTH_URL: 'https://spb.trend-stage.tech/login',
    STATIC_API: 'https://static.trend-stage.tech',
    VIDEO_CALL_API: 'https://meetings-api.trendrealty.trend-stage.tech',
    VOX_APP_NAME: 'videocalls-dev',
};

const productionApi: IDynamicApi = {
    CLIENT_AUTH_URL: 'https://trendrealty.ru/auth',
    MANAGER_AUTH_URL: 'https://trendagent.ru/login',
    STATIC_API: 'https://selcdn.trendagent.ru/',
    VIDEO_CALL_API: 'https://meetings-api.trendrealty.ru',
    VOX_APP_NAME: 'videocalls',
};

const betaApi: IDynamicApi = {
    ...productionApi,
    CLIENT_AUTH_URL: 'https://beta.trendrealty.ru/auth',
    MANAGER_AUTH_URL: 'https://beta.trendagent.ru/login',
};

export const apiMap: { [x in typeof process.env.API_VER]: IDynamicApi } = {
    beta: betaApi,
    production: productionApi,
    stage: stageApi,
    'team-01': getTeamApi('01'),
    'team-02': getTeamApi('02'),
    'team-03': getTeamApi('03'),
    'team-04': getTeamApi('04'),
    'team-05': getTeamApi('05'),
    'team-06': getTeamApi('06'),
    'team-07': getTeamApi('07'),
    'team-08': getTeamApi('08'),
    'team-09': getTeamApi('09'),
    'team-11': getTeamApi('11'),
};

export const API: IApi = { ...apiMap[process.env.API_VER], ...commonApi };
